import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconBodyFn = /* @__PURE__ */ createRecipe('radio-icon-body', {}, [])

const radioOnlyIconBodyVariantMap = {}

const radioOnlyIconBodyVariantKeys = Object.keys(radioOnlyIconBodyVariantMap)

export const radioOnlyIconBody = /* @__PURE__ */ Object.assign(memo(radioOnlyIconBodyFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconBody',
  __getCompoundVariantCss__: radioOnlyIconBodyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconBodyVariantKeys,
  variantMap: radioOnlyIconBodyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconBodyVariantKeys)
  },
  getVariantProps: radioOnlyIconBodyFn.getVariantProps,
})